var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100 d-flex flex-column",attrs:{"id":"logout"}},[_c('b-row',{staticClass:"flex-grow-1 w-100",attrs:{"no-gutters":"","align-h":"center","align-v":"center"}},[_c('b-spinner',{attrs:{"variant":"dark"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }